import React from 'react'
import { connect } from 'react-redux'

import { Paths } from 'utils/paths'
import { usernameSelector } from 'selectors/users'
import Navigation from 'utils/navigation'


function HeaderNavigation(props) {
  const { username, showDesignGuide } = props
  if (!username) { return null }

  return (
    <ul className="main-nav-links">
      <li>
        <button onClick={() => Navigation.go(Paths.wippers({ username }))}>
          Devices
        </button>
      </li>
      <li>
        <button onClick={() => Navigation.go(Paths.feeds({ username }))}>
          Feeds
        </button>
      </li>
      <li>
        <button onClick={() => Navigation.go(Paths.dashboards({ username }))}>
          Dashboards
        </button>
      </li>
      <li>
        <button onClick={() => Navigation.go(Paths.actions({ username }))}>
          Actions
        </button>
      </li>
      <li>
        <button onClick={() => Navigation.go(Paths.services({ username }))}>
          Power-Ups
        </button>
      </li>
    </ul>
  )
}

const
  mapState = state => ({
    username: usernameSelector(state),
  })

export default connect(mapState)(HeaderNavigation)
